import domtoimage from "dom-to-image-more";
export default {
  methods: {
    addToSliderMix(screenShort, insArr, nameParm) {
      let redId = screenShort.id
      let mainEle = document.getElementById(redId)
      mainEle.getElementsByClassName("content-panel1").forEach(el => {
        el.classList.add("lightC");
      })
      let asgId = this.$sessionData.get('asgID404')
      let notification = this.$notify({
        type: "success",
        text: "Capturing screenshot..",
        duration: 10000
      })
      let tooogleEl = mainEle.getElementsByClassName("hide-on-presentation")
      tooogleEl.forEach(el => {
        el.classList.add("d-none")
      })
      let widgetID = screenShort.id;
      let lightI, darkI;
      const self = this;
      setTimeout(() => {
        domtoimage.toBlob(document.getElementById(widgetID))
          .then((blob) => {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
              lightI = reader.result;
              
              mainEle.getElementsByClassName("content-panel1").forEach(el => {
                el.classList.remove("lightC");
                // el.classList.add("darkC");
              })
              self.showTable = false
              // self.$myPresentationJson.localStorage.getItem('myPresentationJson')
              self.$myPresentationJson.push({
                id: self.$myPresentationJson.length,
                name: nameParm,
                lightImg: lightI,
                darkImg: null,
                asgId: asgId,
                insights: insArr,
                isLayoutT: false
              })
              self.$store.dispatch('storeWidget', self.$myPresentationJson)
              // localStorage.setItem("myPresentationJson", self.$myPresentationJson);
              tooogleEl.forEach(el => {
                el.classList.remove("d-none")
              })
              self.$notify({
                type: "success",
                text: "Screenshot added to Storyboard.",
              })
            }
          });
      }, 1);
    },
  }
}